var React = require('react');

function Plane (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_572","data-name":"Path 572","d":"M1194.618,1301.676l7.5-3.718,8.7-39.594c9.282-4.6,16.768-8.438,17.51-9.136,4.942-2.747,7.51-7.856,7.054-8.779s-5.842-2.09-11.262.3c-1.232.28-8.738,3.874-17.875,8.407l-36.776-17.041-7.5,3.72,26,22.531c-10.84,5.541-19.858,10.306-19.732,10.551l-9.055-4.312-7.75,3.843,8.652,6.2,2.5,5.036-.3,10.638,7.747-3.84,2.05-9.822h0c.121.255,9.374-4.046,20.343-9.319Z","transform":"translate(-1151.433 -1232.11)","fill":"#606060"}));
}

Plane.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 83.994 69.566"};

module.exports = Plane;

Plane.default = Plane;
